export default (state = [], action) => {
  switch (action.type) {
    case 'CREATE_CHECKOUT_TOKEN':
      return action.payload
    default:
      return state
  }
}
